var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.059 9.742l-1.02-1.02a3.625 3.625 0 00-1.584-2.166A3.6 3.6 0 0014.534 6c-2 0-3.622 1.622-3.622 3.622 0 .022.004.045.004.07-.041.003-.083.01-.124.014a8.156 8.156 0 01-6.72-2.481 8.162 8.162 0 003.384 7.76 8.116 8.116 0 01-2.4 1.167A8.137 8.137 0 009.978 17.8a8.14 8.14 0 005.23-1.895 8.164 8.164 0 002.87-5.182l.98-.98z"
  })));
}

export default SvgIconTwitter;